// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".experts-content .areas-box .area{cursor:pointer;font-weight:400 !important}@media (max-width: 767px){.experts-content .areas-box{padding:15px 0}}\n", ""]);
// Exports
module.exports = exports;
